import type { RouteRecordRaw } from 'vue-router';

// Public forms that work without logging in (formerly hosted in WGM Commercial)
const publicForms: RouteRecordRaw[] = [
    {
        // Same path as in WGM Commercial, so old links only need a domain change
        path: '/thuiszorg/vakantie/aanvraag',
        name: 'public-forms.holiday-request',
        component: async () => import('../views/PublicForms/HolidayRequest.vue'),
        meta: {
            title: 'Vakantie aanvraagformulier',
            guest: true,
        },
    },
    {
        path: '/thuiszorg/vakantie/bedankt',
        name: 'public-forms.holiday-request.thank-you',
        component: async () => import('../views/PublicForms/ThankYou.vue'),
        // The thank you page is shared by the public forms; each form passes its own texts (i18n keys)
        props: {
            header: 'thank_you.holiday_request.header',
            message: 'thank_you.holiday_request.message',
        },
        meta: {
            title: 'Bedankt',
            guest: true,
        },
    },
];

export default publicForms;
